import React from 'react';
import { useSelector } from 'react-redux';
import { getMyCars } from '../../../ducks/selectors';
import BankInformation from '../../bank-information/BankInformation';
import VehicleDetails from '../../future-packages/vehicle-details';
import {
  MakePaymentCardWrapper,
  MakePaymentTitle,
  HR,
} from './MakePaymentCard.styles';
import OneTimePaymentForm from '../one-time-payment-form';

const MakePaymentCard = (props: { vehicleId: any }) => {
  const myCars = useSelector(getMyCars);

  const { vehicleId } = props;

  const loanDetailCar: any = myCars.find(
    (car: any) => car.vehicle.vehicleId === Number(vehicleId)
  );

  const isPaidInFull = loanDetailCar?.loanDetails?.loanState === 'PaidOffLoan';

  return (
    <>
      <MakePaymentTitle>
        Make a Payment to Your Bridgecrest Account
      </MakePaymentTitle>
      <MakePaymentCardWrapper>
        <VehicleDetails
          myCar={loanDetailCar.vehicle}
          status={loanDetailCar.status}
        />
        <HR />
        <OneTimePaymentForm />
      </MakePaymentCardWrapper>
      <BankInformation
        vehicleId={vehicleId}
        bankAccounts={loanDetailCar.bankInfo}
        updateBankTrackEvent="one_time_edit_bank_details_tap"
        isPaidInFull={isPaidInFull}
        isHalfView={false}
      />
    </>
  );
};

export default MakePaymentCard;
